import { PERSONALIZED_TIPS_ACTIONS } from '../../actions/personalizedTipsActions';

const personalizedTipsReducer = (state = {
  imageLoaded: 0,
  imagesToBeLoaded: 2,
  recos : null
}, action) => {
  switch (action.type) {
    case PERSONALIZED_TIPS_ACTIONS.FETCH_DATA:
      if (action.payload.length) {
        state = {
          ...state,
          recos: action.payload
        }
      }
      break;
    case PERSONALIZED_TIPS_ACTIONS.IMAGE_LOADED:
      if (state.imageLoaded < state.imagesToBeLoaded) {
        state = {
          ...state,
          imageLoaded: state.imageLoaded + 1
        }
      }
      break;
    case PERSONALIZED_TIPS_ACTIONS.IMAGES_TO_BE_LOADED:
      state = {
        ...state,
        imagesToBeLoaded: state.imagesToBeLoaded + 1
      }
      break;
    default:
      break;
  }
  return state;
};

export default personalizedTipsReducer;
